/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiAssistant,
  AiAssistantRequestInput,
  GetAiAssistantParams,
  ListAiAssistantsParams,
  ListFeaturedAiAssistantsParams,
  PaginatedAiAssistants,
  RecentlyUsedAiAssistantsParams,
  SchemaValidationErrorResponse,
  SearchAiAssistantsParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Assistant
 */
export const createAssistant = (
    aiAssistantRequestInput: MaybeRefOrGetter<AiAssistantRequestInput>,
 signal?: AbortSignal
) => {
      aiAssistantRequestInput = toValue(aiAssistantRequestInput);

      return axiosClient<AiAssistant>(
      {url: `/ai/assistants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiAssistantRequestInput, signal
    },
      );
    }




export const getCreateAssistantMutationKey = () => ['createAssistant'] as const;

export const getCreateAssistantMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistant>>, TError,CreateAssistantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistant>>, TError,CreateAssistantMutationVariables, TContext> => {

const mutationKey = getCreateAssistantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistant>>, CreateAssistantMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAssistant(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistant>>>
    export type CreateAssistantMutationBody = AiAssistantRequestInput
    export type CreateAssistantMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateAssistantMutationVariables = {data: AiAssistantRequestInput}

    /**
 * @summary Create AI Assistant
 */
export const useCreateAssistant = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistant>>, TError,CreateAssistantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistant>>,
        TError,
        CreateAssistantMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAssistantMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Assistants
 */
export const listAiAssistants = (
    params?: MaybeRefOrGetter<ListAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiAssistants>(
      {url: `/ai/assistants`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiAssistantsQueryKey = (params?: MaybeRefOrGetter<ListAiAssistantsParams>,) => {
    return [
    'ai','assistants', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiAssistantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAssistants>>> = ({ signal }) => listAiAssistants(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAssistants>>, TError, TData>
}

export type ListAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAssistants>>>
export type ListAiAssistantsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI Assistants
 */

export function useListAiAssistants<TData = Awaited<ReturnType<typeof listAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of AI Assistants
 */
export const listFeaturedAiAssistants = (
    params?: MaybeRefOrGetter<ListFeaturedAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiAssistants>(
      {url: `/ai/assistants/featured`, method: 'GET',
        params, signal
    },
      );
    }




export const getListFeaturedAiAssistantsQueryKey = (params?: MaybeRefOrGetter<ListFeaturedAiAssistantsParams>,) => {
    return [
    'ai','assistants','featured', ...(params ? [params] : [])
    ] as const;
    }


export const getListFeaturedAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListFeaturedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturedAiAssistantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedAiAssistants>>> = ({ signal }) => listFeaturedAiAssistants(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError, TData>
}

export type ListFeaturedAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedAiAssistants>>>
export type ListFeaturedAiAssistantsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of AI Assistants
 */

export function useListFeaturedAiAssistants<TData = Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListFeaturedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeaturedAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Recently used AI Assistants
 */
export const recentlyUsedAiAssistants = (
    params?: MaybeRefOrGetter<RecentlyUsedAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiAssistants>(
      {url: `/ai/assistants/recently_used`, method: 'GET',
        params, signal
    },
      );
    }




export const getRecentlyUsedAiAssistantsQueryKey = (params?: MaybeRefOrGetter<RecentlyUsedAiAssistantsParams>,) => {
    return [
    'ai','assistants','recently_used', ...(params ? [params] : [])
    ] as const;
    }


export const getRecentlyUsedAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<RecentlyUsedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRecentlyUsedAiAssistantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>> = ({ signal }) => recentlyUsedAiAssistants(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError, TData>
}

export type RecentlyUsedAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>>
export type RecentlyUsedAiAssistantsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Recently used AI Assistants
 */

export function useRecentlyUsedAiAssistants<TData = Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<RecentlyUsedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecentlyUsedAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search AI Assistants
 */
export const searchAiAssistants = (
    params?: MaybeRefOrGetter<SearchAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiAssistants>(
      {url: `/ai/assistants/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchAiAssistantsQueryKey = (params?: MaybeRefOrGetter<SearchAiAssistantsParams>,) => {
    return [
    'ai','assistants','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof searchAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<SearchAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchAiAssistantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAiAssistants>>> = ({ signal }) => searchAiAssistants(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAiAssistants>>, TError, TData>
}

export type SearchAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAiAssistants>>>
export type SearchAiAssistantsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search AI Assistants
 */

export function useSearchAiAssistants<TData = Awaited<ReturnType<typeof searchAiAssistants>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<SearchAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiAssistants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Assistant
 */
export const deleteAiAssistant = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/assistants/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiAssistantMutationKey = () => ['deleteAiAssistant'] as const;

export const getDeleteAiAssistantMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistant>>, TError,DeleteAiAssistantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistant>>, TError,DeleteAiAssistantMutationVariables, TContext> => {

const mutationKey = getDeleteAiAssistantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiAssistant>>, DeleteAiAssistantMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiAssistant(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiAssistant>>>

    export type DeleteAiAssistantMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiAssistantMutationVariables = {id: string}

    /**
 * @summary Delete AI Assistant
 */
export const useDeleteAiAssistant = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistant>>, TError,DeleteAiAssistantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiAssistant>>,
        TError,
        DeleteAiAssistantMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiAssistantMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Assistant Details
 */
export const getAiAssistant = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAiAssistantParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<AiAssistant>(
      {url: `/ai/assistants/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAiAssistantQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAiAssistantParams>,) => {
    return [
    'ai','assistants',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAiAssistantQueryOptions = <TData = Awaited<ReturnType<typeof getAiAssistant>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAiAssistantParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistant>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiAssistantQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAssistant>>> = ({ signal }) => getAiAssistant(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiAssistant>>, TError, TData>
}

export type GetAiAssistantQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAssistant>>>
export type GetAiAssistantQueryError = ErrorType<void>


/**
 * @summary AI Assistant Details
 */

export function useGetAiAssistant<TData = Awaited<ReturnType<typeof getAiAssistant>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAiAssistantParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistant>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiAssistantQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update AI Assistant
 */
export const updateAiAssistant = (
    id: MaybeRefOrGetter<string>,
    aiAssistantRequestInput: MaybeRefOrGetter<AiAssistantRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
aiAssistantRequestInput = toValue(aiAssistantRequestInput);

      return axiosClient<AiAssistant>(
      {url: `/ai/assistants/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aiAssistantRequestInput, signal
    },
      );
    }




export const getUpdateAiAssistantMutationKey = () => ['updateAiAssistant'] as const;

export const getUpdateAiAssistantMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiAssistant>>, TError,UpdateAiAssistantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiAssistant>>, TError,UpdateAiAssistantMutationVariables, TContext> => {

const mutationKey = getUpdateAiAssistantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiAssistant>>, UpdateAiAssistantMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiAssistant(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiAssistant>>>
    export type UpdateAiAssistantMutationBody = AiAssistantRequestInput
    export type UpdateAiAssistantMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAiAssistantMutationVariables = {id: string;data: AiAssistantRequestInput}

    /**
 * @summary Update AI Assistant
 */
export const useUpdateAiAssistant = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiAssistant>>, TError,UpdateAiAssistantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiAssistant>>,
        TError,
        UpdateAiAssistantMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAiAssistantMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive AI Assistant
 */
export const archiveAiAssistant = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/assistants/${id}/archive`, method: 'PUT', signal
    },
      );
    }




export const getArchiveAiAssistantMutationKey = () => ['archiveAiAssistant'] as const;

export const getArchiveAiAssistantMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistant>>, TError,ArchiveAiAssistantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistant>>, TError,ArchiveAiAssistantMutationVariables, TContext> => {

const mutationKey = getArchiveAiAssistantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAiAssistant>>, ArchiveAiAssistantMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveAiAssistant(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAiAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAiAssistant>>>

    export type ArchiveAiAssistantMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ArchiveAiAssistantMutationVariables = {id: string}

    /**
 * @summary Archive AI Assistant
 */
export const useArchiveAiAssistant = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistant>>, TError,ArchiveAiAssistantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveAiAssistant>>,
        TError,
        ArchiveAiAssistantMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveAiAssistantMutationOptions(options), queryClient);
    }
